import React,{useEffect} from 'react'
import { Select ,Button} from 'antd';
import { languages } from '../../../utils/Constants/Constants';
import { CometdActions } from '../../../cometD/cometD-action';
import { useCometdContext } from '../../../cometD/cometdProvider';
const onSearch = (value) => {
  console.log('search:', value);
};

const MessageS1 = (props) => {
  const {isShowLanguageDropdown, setIsShowLanguageDropdown,selectedLanguage,setSelectedLanguage,sessionId}=props

  const cometd = useCometdContext();
  useEffect(()=>{
    const storedLanguage = (sessionStorage.getItem("selectedLanguage"));
if(!storedLanguage)(setSelectedLanguage(languages[0].value))
  },[])
  const onSend = () => {
    setIsShowLanguageDropdown(false)
    sessionStorage.setItem("showLanguageDropdown", false);
    const { changeLanguageCometd } = CometdActions(cometd);
    sessionStorage.setItem("selectedLanguage", selectedLanguage);
    changeLanguageCometd(sessionId, selectedLanguage);

    }
    const languagearray = languages.reduce((acc, lang) => {
      acc[lang.value] = lang.label;
      return acc;
    }, {});
    console.log(languagearray,sessionId)
    const onChange = (value) => {
      console.log(`selected ${value}`);
      setSelectedLanguage(value)
      // sessionStorage.setItem("selectedLanguage", JSON.stringify(value));

    };
    console.log(selectedLanguage)
  return (
    <>
    <div style={{display: "flex", alignItems: "end",}}>
        <div class="s360-message-box-language">Please provide the following before we start</div>
        </div>
        <div class="s360-message-box-language">  
   {isShowLanguageDropdown ? <>
    <p>Language preferred</p>
    <Select
    showSearch
    optionFilterProp="label"
    defaultValue={languages[0].label}
    onChange={onChange}
    placeholder="Select language"
    onSearch={onSearch}
   style={{width:"200px"}}
    options={languages}
  />
   <div style={{paddingTop:"10px"}}>
  <Button type="primary" onClick={onSend}>Send</Button>
  </div>
  </>:
  <p>
    your preferred language is <b>{languagearray[selectedLanguage]}</b>
  </p>
  }
 
  </div>
  </>
  )
}

export default MessageS1